import { render, staticRenderFns } from "./test_service.vue?vue&type=template&id=5fd666b5&"
import script from "./test_service.vue?vue&type=script&lang=js&"
export * from "./test_service.vue?vue&type=script&lang=js&"
import style0 from "./test_service.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports